<mat-card>
    <mat-card-content style="user-select: none; min-height: calc(100vh - 235px)">
        <h2 style="margin-top: 0px;">Navigating the Portal</h2>
    </mat-card-content>
</mat-card>